import { async } from 'widgets-for-react'
import { CollectionsData } from './collectionsLoaderState'

export const collectionsLoaderWidget = async<CollectionsData>
